import { Home } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PaymentFailed() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="bg-white p-6 rounded shadow text-center max-w-md">
        <h2 className="text-xl font-semibold text-red-600">
          Payment Failed...
        </h2>
        <p className="text-sm text-gray-500 mt-2">
          Your payment was not successful. Please try again.
        </p>

        <button
          onClick={() => navigate("/")}
          className="mt-4 bg-blue-600 text-white px-4 py-2 rounded"
        >
          <Home className="inline w-4 h-4 mr-1" />
          Go Home
        </button>
      </div>
    </div>
  );
}
